var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPetsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67818 12.7998C7.81556 12.7998 8.73759 11.9044 8.73759 10.7998C8.73759 9.69524 7.81556 8.7998 6.67818 8.7998C5.5408 8.7998 4.61877 9.69524 4.61877 10.7998C4.61877 11.9044 5.5408 12.7998 6.67818 12.7998Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3851 9.59961C11.5225 9.59961 12.4445 8.70418 12.4445 7.59961C12.4445 6.49504 11.5225 5.59961 10.3851 5.59961C9.24771 5.59961 8.32568 6.49504 8.32568 7.59961C8.32568 8.70418 9.24771 9.59961 10.3851 9.59961Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3277 9.59961C16.4651 9.59961 17.3871 8.70418 17.3871 7.59961C17.3871 6.49504 16.4651 5.59961 15.3277 5.59961C14.1903 5.59961 13.2683 6.49504 13.2683 7.59961C13.2683 8.70418 14.1903 9.59961 15.3277 9.59961Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0346 12.7998C20.172 12.7998 21.094 11.9044 21.094 10.7998C21.094 9.69524 20.172 8.7998 19.0346 8.7998C17.8972 8.7998 16.9752 9.69524 16.9752 10.7998C16.9752 11.9044 17.8972 12.7998 19.0346 12.7998Z",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2554 15.0876C16.5388 14.2716 15.9374 13.5756 15.2125 12.7596C14.8336 12.3276 14.3476 11.8956 13.7709 11.7036C13.6803 11.6716 13.5897 11.6476 13.4991 11.6316C13.2931 11.5996 13.0707 11.5996 12.8566 11.5996C12.6424 11.5996 12.42 11.5996 12.2058 11.6396C12.1152 11.6556 12.0246 11.6796 11.9339 11.7116C11.3573 11.9036 10.8795 12.3356 10.4924 12.7676C9.77568 13.5836 9.17434 14.2796 8.44943 15.0956C7.3703 16.1436 6.04404 17.3036 6.29117 18.9276C6.53006 19.7436 7.13141 20.5516 8.21053 20.7836C8.81188 20.9036 10.7312 20.4316 12.7742 20.4316H12.9225C14.9654 20.4316 16.8848 20.8956 17.4861 20.7836C18.5652 20.5516 19.1666 19.7356 19.4055 18.9276C19.6608 17.2956 18.3346 16.1356 17.2554 15.0876Z",
    fill: "#494949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2441 20.8L4.61877 4.86666L5.46868 4L21.094 19.9333L20.2441 20.8Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPetsIcon);
export default __webpack_public_path__ + "static/media/NoPetsIcon.c4b4ffd40821151db7d9c4ca54507e88.svg";
export { ForwardRef as ReactComponent };